import React from 'react';
import { ClassFareTableProps } from '../../types';
import '../../../styles/ClassFareTable.css';

export default function ClassFareTable({ title, seoTitle, headers, list }: ClassFareTableProps) {
  if (!list || list.length === 0) {
    return null;
  }

  const titleClass = seoTitle ? 'classFareTitle hasSubtitle' : 'classFareTitle';

  return (
    <div className="classFareContainer">
      <h2 className={titleClass}>{title}</h2>
      {seoTitle && <p className="classFareSeoTitle">{seoTitle}</p>}
      <div className="classFareTableWrapper">
        <table className="classFareTable">
          <colgroup>
            <col />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th>{headers.class}</th>
              <th>{headers.fare}</th>
            </tr>
          </thead>
          <tbody>
            {list.map((item) => (
              <tr key={item.class}>
                <td>{item.class}</td>
                <td>{item.fare}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
